import(/* webpackMode: "eager" */ "/u0/app/app/global-error.tsx");
